<template>
  <div class="takepart">
    <div v-if="haveRight">
      <header class="takepart-header">
        <h1 class="takepart-username">
          <span>{{userInfo.worksite.shortName}} - {{userInfo.worksite.schoolCampus}}</span>
          <span class="worksite-info">
            <p class="school-name">（{{userInfo.nameZH}}）</p>
          </span>
        </h1>

      </header>
      <section class="takepart-main">
        <div class="takepart-scanning-status">
          <div class="takepart-qrcode" :class="canTakeaway?'green':'red'">{{expressInfo.sn}}</div>
          <div class="tag" :class="canTakeaway?'green':'red'">{{expressInfo.tag}}</div>
        </div>

        <div class="weui-cells takepart-form">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>当前状态</p>
            </div>
            <div class="weui-cell__ft">{{status}}</div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>快递公司</p>
            </div>
            <div class="weui-cell__ft">{{expressInfo.ex}}</div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>快递单号</p>
            </div>
            <div class="weui-cell__ft">{{expressInfo.en}}</div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>收件人员</p>
            </div>
            <div class="weui-cell__ft">{{expressInfo.re}}</div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>收件手机</p>
            </div>
            <div class="weui-cell__ft">{{expressInfo.rp}}</div>
          </div>
        </div>
        <div class="scanBtn" @click="scan">
          <i class="iconfont icon-saomiaoshibie380"></i>
        </div>
      </section>
      <footer>
        <div class="takepart-footer">
          <div class="takepart-footer-item sureintakepart" :class="canTakeaway?'able':'disable'" @click="takepart">
            <a href="javascript:;">确认取件</a>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      userInfo: {
        worksite: {}
      },
      haveRight: false,
      expressInfo: {
        ex: "",
        en: "",
        sn: "-",
        roid: "",
        re: "",
        rp: "",
        tag: "-"
      },
      status: "",
      canTakeaway: false
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["scanQRCode"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        let openid = response.data.data.openid;
        // 根据openid 获取用户信息
        axios
          .get("/auth/employee/getByOpen/" + openid)
          .then(res => {
            if (res.data.success) {
              this.haveRight = true;
              that.userInfo = res.data.user;
            } else {
              weui.alert("请先绑定后台操作用户", function() {
                that.$router.push("/bind/takepart/" + that.encodeToken);
              });
            }
          })
          .catch(err => {
            weui.topTips("获取用户信息失败", 2000);
          });
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    scan() {
      let that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let params = JSON.parse(res.resultStr); // 当needResult 为 1 时，扫码返回的结果
          axios
            .get("/api/expressTosend/checkqr", { params })
            .then(response => {
              if (!response.data.success) {
                weui.alert(response.data.message);
              } else {
                // 校验通过的二维码
                that.expressInfo = params;
                that.status = response.data.data.statusStr;
                that.canTakeaway = response.data.data.canTakeaway;
              }
            })
            .catch(error => {
              weui.alert("二维码校验失败");
            });
        }
      });
    },
    takepart() {
      if (!this.expressInfo.sn || this.expressInfo.sn == "-") {
        weui.alert("请先扫一扫取件码");
      } else {
        if (!this.canTakeaway) {
          weui.alert("不能取走【" + this.status + "】状态的快递");
          return;
        } else {
          let params = {
            worksiteCode: this.userInfo.worksite.siteCode,
            expressNo: this.expressInfo.en,
            storageNo: this.expressInfo.sn,
            signOpenid:
              this.expressInfo.roid ||
              this.expressInfo.aoid ||
              this.expressInfo.poid,
            tag: this.expressInfo.tag
          };
          if (this.expressInfo.poid) {
            params.isPaotui = true;
          } else {
            params.isPaotui = false;
          }
          axios
            .put("/api/expressTosend/takepart", params)
            .then(response => {
              if (!response.data.success) {
                weui.alert(response.data.message);
              } else {
                weui.toast("确认取件成功", 1500);
                this.canTakeaway = !this.canTakeaway;
                this.expressInfo = {
                  ex: "",
                  en: "",
                  sn: "-",
                  roid: "",
                  re: "",
                  rp: "",
                  tag: "-"
                };
                this.status = "";
              }
            })
            .catch(error => {
              weui.alert("确认取件失败");
            });
        }
      }
    }
  }
};
</script>
<style scoped>
.size-25 {
  font-size: 25px;
}
.takepart {
  margin: 0 auto;
  position: relative;
  font-size: 16px;
}
.takepart-header {
  text-align: center;
}
.takepart-username {
  height: 50px;
  line-height: 50px;
  background-color: #1aad19;
  color: white;
  position: relative;
  font-size: 25px;
}
.takepart-local {
  margin-top: 20px;
}
.takepart-out-icon {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 25px;
}
.takepart-header-nav {
  margin-top: 20px;
  height: 33px;
  position: relative;
}
.takepart-header-nav:before {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 2px;
  border-bottom: 1px solid #ccc;
}
.courier-company {
  position: absolute;
  left: 0px;
  height: 100%;
}
.courier-company-taget {
  position: absolute;
  right: 0px;
  height: 100%;
}
.takepart-main {
  padding-bottom: 60px;
}
.takepart-select {
  margin-top: 10px;
  display: flex;
  justify-content: space-around;
}

.takepart-select-item {
  text-align: center;
  height: 36px;
  line-height: 36px;
  width: 85px;
  border: 1px solid #ddd;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.takepart-select-item.select {
  color: red;
  border: 1px solid red;
}
.takepart-scanning-status {
  width: 90%;
  margin: 30px auto;
  text-align: center;
}
.takepart-qrcode {
  margin: 0 auto;
  border: 1px dotted #000;
  height: 60px;
  line-height: 60px;
  font-size: 40px;
  text-align: center;
  width: 68%;
  display: inline-block;
}
.takepart-qrcode.green {
  color: #1aad19;
  box-shadow: 0px 0px 10px #1aad19;
}
.takepart-qrcode.red {
  color: red;
  box-shadow: 0px 0px 10px red;
}
.tag {
  width: 28%;
  border: 1px dotted #000;
  height: 60px;
  line-height: 60px;
  font-size: 40px;
  text-align: center;
  display: inline-block;
}
.tag.green {
  color: #1aad19;
  box-shadow: 0px 0px 10px #1aad19;
}
.tag.red {
  color: red;
  box-shadow: 0px 0px 10px red;
}
.takepart-form {
  width: 90%;
  margin: 0 auto;
}
.form-item-label {
  width: 80px;
}
.form-item-input {
  flex: 1;
  text-align: left;
}
.form-item-input input {
  display: block;
  border: 0px;
  width: 100%;
  height: 100%;
  line-height: 34px;
  padding-left: 5px;
  border: 1px solid #eee;
}
.takepart-input-num {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
.takepart-input-num input {
  width: 30px;
  border: 0px;
  border-bottom: 1px solid #ccc;
  font-size: 30px;
  text-align: center;
}
.takepart-server {
  width: 90%;
  margin: 0 auto;
  margin-top: 15px;
}
.takepart-server-item {
  font-size: 20px;
  text-align: left;
  border: 1px solid #ddd;
  padding: 5px;
  position: relative;
  overflow: hidden;
  padding-left: 20px;
}
.takepart-server-item + .takepart-server-item {
  margin-top: 10px;
}

.takepart-server-item .item-icon {
  width: 30px;
  text-align: center;
  vertical-align: middle;
  font-size: 22px;
  display: inline-block;
}

.takepart-server-item .item-server {
  text-align: left;
  display: inline-block;
  vertical-align: middle;
  font-size: 22px;
  position: relative;
}
.item-server + .item-server {
  margin-left: 20px;
}
.takepart-server-item.select {
  border: 1px solid red;
}
.takepart-server-item.select:before {
  content: "";
  position: absolute;
  right: -15px;
  top: -15px;
  width: 30px;
  height: 30px;
  background-color: red;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
}
.takepart-server-item.select:after {
  content: "\f00c";
  position: absolute;
  right: 0px;
  top: 0px;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  color: white;
  font-size: 12px;
}
.scanBtn {
  margin: 20px auto;
  text-align: center;
  border: 1px solid #1aad19;
  height: 100px;
  width: 100px;
  line-height: 100px;
  border-radius: 50px;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0px 0px 20px #1aad19;
}
.scanBtn i {
  color: #1aad19;
  font-size: 46px;
}
.takepart footer {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 60px;
}
.takepart-footer {
  display: flex;
  border-top: 1px solid #eee;
  position: relative;
}
.takepart-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
.takepart-footer-item.select {
  color: orange;
}
.takepart-footer-item_text {
  font-size: 16px;
  margin-top: -10px;
}
.sureintakepart {
  line-height: 60px;
  color: white;
  margin-top: 0px;
}
.sureintakepart.able {
  background-color: #1aad19;
}
.sureintakepart.disable {
  background-color: gray;
}
.sureintakepart a {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.worksite-info {
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  right: 0;
}
.school-name {
  line-height: 50px;
  margin-right: 10px;
  padding-top: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/TakePart.vue